var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({class:_vm.svgClass,attrs:{"height":_vm.iconHeight,"width":_vm.iconWidth}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":_vm.iconName}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }